/*
 * NOTE: please don't modify this file without speaking to knowledge.
 *
 * These types are the shared interfaces with the knowledge micro-frontend.
 *
 * Types are duplicated as knowledge can't copy imports.
 */

import { IconNames } from '@dixa/lib-shared-habla';
import { ReactNode } from 'react';

export type StatusT = 'default' | 'success' | 'warning' | 'danger';
export type NotificationT = {
  title: string;
  text: ReactNode;
  status: StatusT;
  icon: IconNames;
  className?: string;
  time?: number;
  startTime: null | number;
  waitingTime: string | null;
  reason: string | null;
  hideCloseAction?: boolean;
  leftAction: NotificationActionT | null;
};

export enum ExternalResourceType {
  Queue = 'QUEUE',
}

export type NotificationActionT = {
  action?: {
    navigate: string;
  };
  text: string;
  disabled?: boolean;
  hidden?: boolean;
};

export enum TranslatingType {
  ARTICLE = 'article',
  BLOCK = 'block',
  TITLE = 'title',
  NONE = 'none',
}

export type TranslatingStatus = {
  type: TranslatingType;
  blockId?: string;
};
